import React from "react";
import { Box, Divider } from "@material-ui/core";
import { IntroText, ButtonLoader } from "../../../components";
import { useTranslation } from "react-i18next";

const ScheduleNervousSystem = ({ updateScheduleData, scheduleData }) => {
  const { t } = useTranslation();

  const handleChange = nervousSystem => {
    updateScheduleData({
      covid19vaxScreening: {
        ...scheduleData.covid19vaxScreening,
        nervous_system: nervousSystem
      }
    });
  };

  return (
    <Box data-cy="schedule-screen-nervous-system">
      <IntroText>{t("schedule.nervous_system.intro_text")}</IntroText>
      <ButtonLoader
        variant="contained"
        color="primary"
        fullWidth
        size="large"
        data-cy="nervous-system-no"
        onClick={e => handleChange(false)}
      >
        {t("schedule.nervous_system.options.no")}
      </ButtonLoader>
      <Box my={2}>
        <Divider variant="middle" />
      </Box>
      <ButtonLoader
        variant="contained"
        fullWidth
        size="large"
        data-cy="nervous-system-yes"
        onClick={e => handleChange(true)}
      >
        {t("schedule.nervous_system.options.yes")}
      </ButtonLoader>
    </Box>
  );
};

export { ScheduleNervousSystem };
